<div class="h5Font submenu-dropdown">
    <div *ngFor="let item of items"
         class="submenu-dd-item {{item.active ? 'submenu-dd-item-active' : 'submenu-dd-item-inactive'}}"
         (click)="handleItemClick(item)"
         attr.data-testid="{{item.testId}}">
        {{item.title | translate}}
    </div>
</div>
